import SupervisedShiftDetailsPage from "@/app/(app)/(crew)/supervising/[shift]/index";

export default SupervisedShiftDetailsPage;
